import { atom } from 'jotai';

/**
 * Whether the Heidi II complimentary-usage banner is eligible to show on Work
 * home. The banner host is the only writer, and the value outlives the host
 * so the get-started checklist stays folded on pages without the banner.
 */
export const heidi2NewUserHomeOnboardingBannerEligibleAtom = atom(false);
